'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _parseCssFont = require('parse-css-font');

var _parseCssFont2 = _interopRequireDefault(_parseCssFont);

var _WixStylesColorUtils = require('./WixStylesColorUtils.js');

var _WixStylesColorUtils2 = _interopRequireDefault(_WixStylesColorUtils);

var _WixStylesFontUtils = require('./WixStylesFontUtils.js');

var _WixStylesFontUtils2 = _interopRequireDefault(_WixStylesFontUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Css = function () {
    function Css(_ref) {
        var css = _ref.css,
            tokens = _ref.tokens,
            defaults = _ref.defaults;
        (0, _classCallCheck3.default)(this, Css);

        if (tokens && defaults) {
            this.tokens = tokens;
            this.defaults = defaults;
        } else {
            this.update({ css: css });
        }
    }

    (0, _createClass3.default)(Css, [{
        key: 'update',
        value: function update(_ref2) {
            var css = _ref2.css;

            var tokens = splitWss(css);
            var defaults = { colors: {}, fonts: {} };

            // Support CssVars style definition as well
            tokens = _lodash2.default.map(tokens, function (token) {
                if (token.type !== 'text') return token;

                var regex = /--(\S*?)\s*:\s*\"([^"]*?)\"/g;
                var match = null;
                while (match = regex.exec(token.text)) {
                    var name = match[1];
                    var value = match[2];
                    if (name.startsWith('color-')) {
                        defaults.colors[name.substr(6)] = value;
                    } else if (name.startsWith('font-')) {
                        defaults.fonts[name.substr(5)] = value;
                    }
                }

                return { type: 'text', text: token.text.replace(/--(\S*)\s*:\s*\"([^"]*?)\";/g, "") };
            });

            // Split for CssVar usage as well
            tokens = _lodash2.default.flatten(_lodash2.default.map(tokens, function (token) {

                if (token.type !== 'text') return [token];

                var parts = _lodash2.default.compact(token.text.split(/"((?:var|px|join|get|opacity|preset|font)[^"]*?)"/g));

                return _lodash2.default.map(parts, function (p) {
                    if (p.startsWith('var(')) {
                        p = p.substr(4, p.length - 5);

                        if (p.indexOf('color-') > -1) {
                            return { type: 'css-var-color', value: p };
                        } else if (p.indexOf('font-') > -1) {
                            return { type: 'css-var-font', value: p };
                        } else if (p.indexOf('number-') > -1) {
                            return { type: 'css-var-number', value: p };
                        }
                    } else if (p.startsWith('px(')) {
                        var startLength = 'px('.length;
                        p = p.substr(startLength, p.length - (startLength + 1));
                        if (p.indexOf('number-') > -1) {
                            return { type: 'css-px-number', value: p };
                        }
                    } else if (p.match(/^fontSize\(/)) {
                        var _startLength = 'fontSize('.length;
                        p = p.substr(_startLength, p.length - (_startLength + 1));
                        return { type: 'css-var-font-size', value: p };
                    } else if (p.match(/^(join|get|opacity)\(/)) {
                        return { type: 'css-var-color', value: p };
                    } else if (p.match(/^(preset|font)\(/)) {
                        return { type: 'css-var-font', value: p };
                    }

                    return { type: 'text', text: p };
                });
            }));

            // Split all text tokens to old fashioned WixRest CSS (extracting all "_@BLAHBLAH", START, END, ...)
            _lodash2.default.each(tokens, function (token) {
                if (token.type !== 'text') return token;

                token.text = _lodash2.default.compact(token.text.split(/"(_@[^"]*?)"|(STARTSIGN|ENDSIGN|DIR|END|START)/g));

                token.text = _lodash2.default.map(token.text, function (t) {
                    var m = null;
                    if (m = t.match(/_@colors\[(.*)\]\s*\|\|\s*(.*)/)) {
                        defaults.colors[m[1]] = m[2];
                        return { type: 'color', key: m[1] };
                    } else if (m = t.match(/_@fonts\[(.*)\]\s*\|\|\s*(.*)/)) {
                        defaults.fonts[m[1]] = m[2];
                        return { type: 'font', key: m[1] };
                    } else {
                        return t;
                    }
                });

                return token;
            });

            this.tokens = tokens;
            this.defaults = defaults;
        }
    }, {
        key: 'serialize',
        value: function serialize() {
            return {
                tokens: this.tokens,
                defaults: this.defaults
            };
        }
    }, {
        key: 'get',
        value: function get(_ref3) {
            var colors = _ref3.colors,
                fonts = _ref3.fonts,
                numbers = _ref3.numbers,
                isRtl = _ref3.isRtl;

            var css = [];

            _lodash2.default.each(this.tokens, function (token) {

                if (token.type === 'text') {

                    _lodash2.default.each(token.text, function (text) {

                        if (text.type === 'color') {
                            css.push(colors[text.key]);
                        } else if (text.type === 'font') {
                            var font = fonts[text.key] || {};
                            var value = fontJoin({ base: font, default: font.family }, fonts);
                            var cssValue = _WixStylesFontUtils2.default.toFontCssValue(value);
                            css.push(cssValue);
                        } else if (text === 'STARTSIGN') {
                            css.push(isRtl ? '' : '-');
                        } else if (text === 'ENDSIGN') {
                            css.push(isRtl ? '-' : '');
                        } else if (text === 'START') {
                            css.push(isRtl ? 'right' : 'left');
                        } else if (text === 'END') {
                            css.push(isRtl ? 'left' : 'right');
                        } else if (text === 'DIR') {
                            css.push(isRtl ? 'rtl' : 'ltr');
                        } else {
                            css.push(text);
                        }
                    });
                } else if (token.type === 'css-var-color') {
                    var value = _WixStylesColorUtils2.default.calcValueFromString({ str: token.value, values: colors });
                    css.push(value);
                } else if (token.type === 'css-var-font') {
                    var _value = _WixStylesFontUtils2.default.calcValueFromString({ str: token.value, values: fonts });
                    var cssValue = _WixStylesFontUtils2.default.toFontCssValue(_value);
                    css.push(cssValue);
                } else if (token.type === 'css-var-number') {
                    var _value2 = numbers[token.value.replace(/^number-/, '')];
                    css.push(_value2);
                } else if (token.type === 'css-px-number') {
                    var _value3 = numbers[token.value.replace(/^number-/, '')] + 'px';
                    css.push(_value3);
                } else if (token.type === 'font') {
                    var _value4 = fontJoin(token, fonts);
                    var _cssValue = _WixStylesFontUtils2.default.toFontCssValue(_value4);
                    css.push(token.type + ': ' + _cssValue + ';');
                } else if (token.type === 'css-var-font-size') {
                    var _value5 = _WixStylesFontUtils2.default.calcValueFromString({ str: token.value, values: fonts });
                    css.push(_value5.size + ';');
                } else {
                    var _value6 = colors[token.fieldId] || _WixStylesColorUtils2.default.calcValueFromString({ str: token.default, values: colors });
                    css.push(token.type + ': ' + _value6 + ';');
                }
            });

            return css.join('');
        }
    }]);
    return Css;
}();

;

function splitWss(str) {

    // Split by '-wss' markers
    var parts = str.split(/(-wss.*?);/);

    var fieldId = null;

    // Run on all parts
    return _lodash2.default.compact(_lodash2.default.map(parts, function (part) {

        // if part does not start with -wss, its a simple string
        if (!part.startsWith('-wss')) {
            if (part.trim()) {
                return {
                    type: 'text',
                    text: part
                };
            } else {
                return null;
            }
        }

        var _part$split = part.split(':'),
            _part$split2 = (0, _slicedToArray3.default)(_part$split, 2),
            attribute = _part$split2[0],
            value = _part$split2[1];

        attribute = attribute.trim();
        value = value.trim();

        switch (attribute) {
            case '-wss':
                fieldId = value;
                return null;

            case '-wss-background-color':
            case '-wss-background':
            case '-wss-color':
            case '-wss-border-color':
            case '-wss-border-top-color':
            case '-wss-border-left-color':
            case '-wss-border-bottom-color':
            case '-wss-border-right-color':
            case '-wss-stroke':
            case '-wss-fill':
                return {
                    type: attribute.substr(5),
                    fieldId: fieldId + '.' + attribute.substr(5).replace(/-/g, ''),
                    default: value
                };

            case '-wss-font':
                var params = (0, _parseCssFont2.default)(value);
                return {
                    type: 'font',
                    base: _lodash2.default.omit(params, 'family'),
                    fieldId: fieldId + '.font',
                    default: params.family
                };

            default:
                console.warn('Unknown wss attribute', attribute);
        }
    }));
}

function fontJoin(token, fonts) {

    if (fonts[token.fieldId]) return;

    var parseFamily = function parseFamily(family) {

        if (family.startsWith('MEDIUM_')) {
            family = family.substr(7);
        }

        var recursive = fonts[family];

        if (recursive) {
            return _lodash2.default.map(recursive.family, function (r) {
                return parseFamily(r);
            }).join(',');
        } else {
            return family;
        }
    };

    var family = _lodash2.default.map(token.default, function (r) {
        return parseFamily(r);
    });

    return _lodash2.default.extend({}, token.base, { family: family });
}

exports.default = Css;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/Wss.js
// module id = 1089
// module chunks = 0